import chroma from 'chroma-js';
import classNames from 'classnames';
import { range } from 'lodash-es';
import React, { PureComponent } from 'react';

import css from './Meter.module.scss';

export interface MeterProps {
  className?: any;
  colors: [string, string];
  current: number;
  defaultColor: string;
  max: number;
}

export class Meter extends PureComponent<MeterProps> {
  static defaultProps: Partial<MeterProps> = {
    max: 10,
  };

  renderBar(scale, index: number) {
    const { current, defaultColor, max } = this.props;
    const backgroundColor = index < current ? scale(index / max) : defaultColor;

    return <div key={index} style={{ backgroundColor }} />;
  }

  render() {
    const { className, colors, max } = this.props;
    const scale = chroma.scale(colors);

    return (
      <div className={classNames(css.meter, className)}>
        {range(max).map((idx) => this.renderBar(scale, idx))}
      </div>
    );
  }
}
